import type { FC } from 'react';
import classNames from 'classnames/bind';
import type { IndividualTogglePropTypes } from '../types/IndividualTogglePropTypes';
import { FAIcon, type IconTheme } from '../../Icons/Icons';
import styles from './IndividualToggle.module.scss';

const cx = classNames.bind(styles);

const IndividualToggle: FC<IndividualTogglePropTypes> = ({
  text,
  icon,
  isActive = false,
  theme,
  disabled,
  className,
  showSuccessStatus,
  showErrorStatus,
  variant = 'default',
  id,
  onSelectionClick,
  ...restProps
}: IndividualTogglePropTypes) => {
  const isSelectionVariant = variant === 'selection';
  const isStatusButton = showSuccessStatus || showErrorStatus;

  const CClassname = cx(
    isSelectionVariant ? 'selection-button' : 'individual-container',
    {
      ...(!isSelectionVariant && {
        [`${icon ? 'icon' : 'text'}-container`]: true,
        ...(disabled
          ? { disabled: true }
          : {
              inactive: !isActive,
              theme,
            }),
      }),
      ...(isSelectionVariant && {
        'selection-default': !isStatusButton && !disabled,
        'selection-selected': isActive && !isStatusButton,
        'selection-success': showSuccessStatus,
        'selection-error': showErrorStatus,
        'selection-disabled': disabled,
      }),
    },
    className,
  );

  const handleClick = () => {
    if (isSelectionVariant) {
      if (isStatusButton || disabled) {
        return;
      }
      if (onSelectionClick && id) {
        onSelectionClick(id);
      }
    }
  };

  return (
    <div
      {...restProps}
      className={CClassname}
      {...(isSelectionVariant && { onClick: handleClick })}
      data-testid="individual-test-id"
    >
      {isSelectionVariant ? (
        <div className={styles['selection-title']}>
          <span>{text}</span>
        </div>
      ) : icon ? (
        <FAIcon {...icon} theme={theme as IconTheme} className={styles['icon']} />
      ) : (
        text
      )}
    </div>
  );
};

export default IndividualToggle;
